import { DayPickerNav } from 'app/components/date/DayPickerNav';
import { DayPicker } from 'app/components/date/DayPicker';
import React, { RefObject } from 'react';

export type DateRangePickerContentProps = {
  getIsPreviousButton: () => boolean;
  setMonthScroll: (value: number) => void;
  monthScroll: number;
  minDepartureDate: Date;
  departureDate: Date;
  returnDate: Date;
  departureFocused: boolean;
  returnFocused: boolean;
  returnDateVisible: boolean;
  handleDepartureChange: (isFocused: boolean) => void;
  handleReturnChange: (isFocused: boolean) => void;
  handleDepartureDateChange: (date: Date) => void;
  handleReturnDateChange: (date: Date) => void;
  afterSelectFocusAction: ({ focusedItem }: { focusedItem: 'departure' | 'arrival' }) => void;
  returnInput: RefObject<HTMLInputElement>;
};
export const DateRangePickerContent = ({
  getIsPreviousButton,
  setMonthScroll,
  monthScroll,
  minDepartureDate,
  departureDate,
  returnDate,
  departureFocused,
  returnFocused,
  returnDateVisible,
  handleDepartureChange,
  handleReturnChange,
  handleDepartureDateChange,
  handleReturnDateChange,
  afterSelectFocusAction,
  returnInput,
}: DateRangePickerContentProps) => {
  return (
    <DayPickerNav
      showPreviousButton={getIsPreviousButton()}
      onPreviousClick={() => setMonthScroll(monthScroll - 1)}
      onNextClick={() => setMonthScroll(monthScroll + 1)}
    >
      <DayPicker
        monthScroll={monthScroll}
        minDepartureDate={minDepartureDate}
        departureDate={departureDate}
        returnDate={returnDate}
        departureFocused={departureFocused}
        returnFocused={returnFocused}
        returnDateVisible={returnDateVisible}
        setDepartureFocused={handleDepartureChange}
        setReturnFocused={handleReturnChange}
        onDepartureDateChange={handleDepartureDateChange}
        onReturnDateChange={handleReturnDateChange}
        afterSelectFocusAction={afterSelectFocusAction}
        returnInput={returnInput}
      />
    </DayPickerNav>
  );
};
